const API_VERSION = {
  V1: "/v1/api",
};

const API_ROUTES = {
  V1: {
    LOGIN: `${API_VERSION.V1}/accounts/sign-in/`,
    LOGOUT: `${API_VERSION.V1}/accounts/logout/`,
    FORGET_PASSWORD: `${API_VERSION.V1}/accounts/forgot-password/`,
    SIGNUP: `${API_VERSION.V1}/accounts/sign-up/`,
    TAGS: `${API_VERSION.V1}/accounts/tags/`,
    CREATE_PROFILE: `${API_VERSION.V1}/seller/profile/`,
    PRE_SIGNED_URL: `${API_VERSION.V1}/accounts/upload-image/`,
    GET_CITYS: `${API_VERSION.V1}/accounts/cities/`,
    GET_CITYS_BY_COUNTRY: `${API_VERSION.V1}/accounts/city/`,
    GET_COUNTRYS: `${API_VERSION.V1}/accounts/country/`,
    CHECK_EMAIL: `${API_VERSION.V1}/seller/check-email/`,
    SELLER_PROFILE: `${API_VERSION.V1}/seller/profile/`,
    SHOPIFY_PROFILE: `${API_VERSION.V1}/shopify/auth/`,
    SELLER_COLLECTIONS: `${API_VERSION.V1}/accounts/collections/`,
    SELLER_CATEGORIES: `${API_VERSION.V1}/accounts/categories/`,
    CREATE_PRODUCT: `${API_VERSION.V1}/accounts/products/`,
    GET_PRODUCT: `${API_VERSION.V1}/accounts/products/`,
    GET_CONNECT_STRIPE: `${API_VERSION.V1}/accounts/stripe-connect/`,
    GET_SELLER_EARNINGS: `${API_VERSION.V1}/seller/earnings/`,
    GET_FAVOURITES:`${API_VERSION.V1}/seller/favourite-products/`,
    GET_ORDERS: `${API_VERSION.V1}/seller/seller-orders/`,
    GET_FILTER_BY_STOCK : `${API_VERSION.V1}/seller/stock/?stock_status=`,
    GET_SELLER_DASHBOARD: `${API_VERSION.V1}/seller/dashboard-summary/`,
    GET_SELLER_INVOICES: `${API_VERSION.V1}/seller/invoices/`,
    DOWNLOAD_SELLER_INVOICES: `${API_VERSION.V1}/seller/invoices/:id/download/`,
    GET_SELLER_MARK_SHIPPED: `${API_VERSION.V1}/seller/seller-orders/:id/`,
    STATUS_COLOR: `${API_VERSION.V1}/buyer/order-status/`,
    STATUS_SELLER_COLOR: `${API_VERSION.V1}/seller/seller-status/`,
    TERMS_AND_CONDITION: `${API_VERSION.V1}/accounts/terms-and-conditions/`,
    PRIVACY_POLICY: `${API_VERSION.V1}/accounts/privacy-policy/`,
    CUSTOMER_SUPPORT: `${API_VERSION.V1}/accounts/support-information/`,
    RESET_PASSWORD: `${API_VERSION.V1}/accounts/reset-password/`,
    RESET_LINK_CHECK: `${API_VERSION.V1}/accounts/reset-link-check/`,
    SHOPIFY_LIST: `${API_VERSION.V1}/shopify/products/preview/`,
    MIGRATE_INVENTORY: `${API_VERSION.V1}/shopify/products/bulk-map/`,
    SHOPIFY_STATUS: `${API_VERSION.V1}/shopify/status/`,
    FAQ: `${API_VERSION.V1}/accounts/faqs/`,
    NEWSLETTER: `${API_VERSION.V1}/accounts/newsletter/`,
    SELLER_COLOURS: `${API_VERSION.V1}/accounts/colors/`,
    SELLER_SIZES: `${API_VERSION.V1}/accounts/sizes/`,
    SHOPIFY_ACCOUNT_CHECK: `${API_VERSION.V1}/accounts/shopify-ui/`,
    OPTION_TYPES: `${API_VERSION.V1}/accounts/option-types/`,
    OPTION_TYPE_DETAIL: `${API_VERSION.V1}/accounts/option-types/:id/values/`,
    OPTION_VALUES: `${API_VERSION.V1}/accounts/option-values/`,
    PRODUCT_VARIANTS: `${API_VERSION.V1}/accounts/products/:id/variants/`,
    UPDATE_VARIANT: `${API_VERSION.V1}/accounts/variants/:id/`,
    DELETE_VARIANT: `${API_VERSION.V1}/accounts/variants/:id/`
  },
};

export default API_ROUTES;
